import React from 'react';
import PropTypes from 'prop-types';
import { useSnapshot } from 'valtio';
import { refsStore, eventsStore, poiStore, gmapStore, videoStore, datareadStore } from '../managers/globalState';

import { EVENT_CATEGORIES, POI_CATEGORIES, GMAP_CATEGORIES, MISSION_TIME_GROUPS } from '../config/constants';
import DateTimeDisplay from './date_time_display';


const LeftContent = ({
	isMobile,
	title = null,
	subtitle,
	open,
	type,
	toggle,
	toggleOverlay,
	hideTitle = false,
	category,
	hideButton = false,
	showDateAndTime,
	pioneer
}) => {
	// Get the showOnGlobe, year and category index global state.
	const { showOnGlobe, showOnGlobePoI, showOnGlobeGmap, yearIndex, categoryIndex, missionTimeIndex } = useSnapshot(eventsStore.state, poiStore.state);

	// Get the content manager using the global state 'get' reference.
	const { get } = useSnapshot(refsStore.state);
	const { eventYears } = get('content');
	const { poiYears } = get('content');
	const { gmapYears } = get('content');

	const { isColorBarShowing } = useSnapshot(datareadStore.state);

	const mobileExpandIcon = 'assets/images/' + (open ? 'icon_minus.svg' : 'icon_plus.svg');
	const expandIcon = 'assets/images/' + (open ? 'chevron_down.svg' : 'chevron_up.svg');

	// We should handle the dynamic subtitle generation when the subtitle is created in contentManager.getDisplayData()
	// Rather than resetting it here.
	let dynamicSubtitle = subtitle;

	// Handle the dyanamicSubtitle case when we are using video data to populate the leftContent.
	const { videoId } = useSnapshot(videoStore.state);
	if (videoId) {
		const videoManager = get('video');
		const videoType = videoManager.getVideoType(videoId);
		if (videoType === 'global' || videoType === 'geoLocated') {
			dynamicSubtitle = subtitle;
		}
	}

	let showEvenTitle = false;
  let showPoITitle = false;
  let showGmapTitle = false;
	const router = get('route');

	if (router?._history?.location?.pathname) {
		const { pathname } = router._history.location;
		showEvenTitle = pathname.indexOf('event') >= 0 || pathname.indexOf('spacecraft') >= 0;
		showPoITitle = pathname.indexOf('poi') >= 0 || pathname.indexOf('spacecraft') >= 0;
		showGmapTitle = pathname.indexOf('gmap') >= 0 || pathname.indexOf('spacecraft') >= 0;
	}

	   if (showOnGlobe && !showEvenTitle) {
		/*let event = EVENT_CATEGORIES[categoryIndex] || 'event';
		console.log("events view on globe", event)
		event = event.charAt(0).toUpperCase() + event.slice(1);*/
		

		return (
			<>
				{!isMobile && (
					<div className='clickable section-title' onClick={toggle}>الكوارث الطبيعية</div>
				)}
				<div
					className='clickable title-container'
					onClick={isMobile ? toggleOverlay : toggle}
				>
				</div>
				{showDateAndTime && (
					<div className='title-container'>
            <DateTimeDisplay />
					</div>
				)}
			</>
		);
	}
	if (showOnGlobePoI && !showPoITitle) {
		/*let poi = POI_CATEGORIES[poicategoryIndex][1] || 'poi';
		poi = poi.charAt(0).toUpperCase() + poi.slice(1);*/

		return (
			<>
				{!isMobile && (
					<div className='clickable section-title' onClick={toggle}>أبرز المعالم</div>
				)}
				<div
					className='clickable title-container'
					onClick={isMobile ? toggleOverlay : toggle}
				>
				</div>
				{showDateAndTime && (
					<div className='title-container'>
						<ArabicDateDisplay className='DateDisplay outline' pioneer={pioneer} manager={get('time')} utcLocal='local' format='earthDate' />
						<ArabicTimeDisplay className='DateDisplay outline' pioneer={pioneer} manager={get('time')} utcLocal='local' format='earthTime' updateInterval={500} />
					</div>
				)}
			</>
		);
	}

	if (showOnGlobeGmap && !showGmapTitle) {

		return (
			<>
				{!isMobile && (
					<div className='clickable section-title' onClick={toggle}>الخرائط الجيولوجية</div>
				)}
				<div
					className='clickable title-container'
					onClick={isMobile ? toggleOverlay : toggle}
				>
				</div>
				{showDateAndTime && (
					<div className='title-container'>
						<ArabicDateDisplay className='DateDisplay outline' pioneer={pioneer} manager={get('time')} utcLocal='local' format='earthDate' />
						<ArabicTimeDisplay className='DateDisplay outline' pioneer={pioneer} manager={get('time')} utcLocal='local' format='earthTime' updateInterval={500} />
					</div>
				)}
			</>
		);
	}


	return (
		<>
			{!isMobile && (
				<div className='clickable section-title' onClick={toggle}>
					{category}
				</div>
			)}
			<div
				className={`clickable title-container${!isColorBarShowing || open ? '-no-colorbar' : ''}`}
				onClick={isMobile ? toggleOverlay : toggle}
			>
				{!hideTitle && title && <span className='title outline'>{title}</span>}
				{isMobile
					? (
						!hideButton && (
							<div className='icon'>
								<img id='plus' src={mobileExpandIcon} alt='Expand icon' />
							</div>
						)
					)
					: (
						<span className='icon'>
							<img id='chevron' src={expandIcon} alt='Expand icon' />
						</span>
					)}
			</div>
			{MISSION_TIME_GROUPS[missionTimeIndex] === 'Current'
				? (
					showDateAndTime && (
						<div className='title-container'>
							<ArabicDateDisplay className='DateDisplay outline' pioneer={pioneer} manager={get('time')} utcLocal='local' format='earthDate' />
							<ArabicTimeDisplay className='DateDisplay outline' pioneer={pioneer} manager={get('time')} utcLocal='local' format='earthTime' updateInterval={500} />
						</div>
					)
				)
				: showDateAndTime && (
					<div className='title-container'>
						{
							type === 'spacecraft' ?
								(
									<div className='date-time outline'>
										{subtitle}
									</div>
								)
								: <DateTimeDisplay inline />
						}

					</div>
				)}
			{(type === 'event' || type == 'poi' || type == 'gmap'
				|| (!isMobile) || (type === 'spacecraft' && open)) && (
					<div className='subtitle outline'>
						{type === 'vitalsign' ? dynamicSubtitle : subtitle}
					</div>
			)}
		</>
	);
};

LeftContent.propTypes = {
	hideTitle: PropTypes.bool,
	hideButton: PropTypes.bool,

	isMobile: PropTypes.bool.isRequired,
	open: PropTypes.bool.isRequired,
	showDateAndTime: PropTypes.bool.isRequired,
	category: PropTypes.string.isRequired,
	title: PropTypes.string,
	subtitle: PropTypes.string,
	type: PropTypes.string.isRequired,
	toggle: PropTypes.func.isRequired,
	toggleOverlay: PropTypes.func.isRequired,
	pioneer: PropTypes.shape({}).isRequired
};

export default LeftContent;
